module.exports = __webpack_public_path__ + "img/step1_3.c957c6ec.jpg";